module.exports = __webpack_public_path__ + "static/media/diprospero.e3b29099.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/tizon_tardio_papa/curativa/diprospero.png
// module id = 2011
// module chunks = 3